// @ts-nocheck
class HoverTextHandler extends HTMLElement {
    constructor() {
      super();
      
      // Only initialize on desktop devices (not mobile/touch)
      if (window.innerWidth < 750 || 'ontouchstart' in window) {
        return;
      }
      
      const section = this.closest('[data-hover-content]');
      if (!section) return;
      
      this.hoverItems = section.querySelectorAll('[data-hover-item]');
      this.hoverTitle = section.querySelector('[data-hover-title]');
      this.hoverText = section.querySelector('[data-hover-text]');
      this.isTransitioning = false;
  
      if (!this.hoverTitle || !this.hoverText) return;
  
      this.hoverItems.forEach((item) => {
        const title = item.dataset?.title;
        const text = item.dataset?.text;
  
        item.addEventListener('mouseover', () => {
          // Don't trigger if already transitioning or if it's the same content
          if (this.isTransitioning || 
              (this.hoverTitle?.innerText === title && this.hoverText?.innerHTML === text)) {
            return;
          }
          
          this.updateContent(title, text, item);
        });
      });
    }
    
    updateContent(title, text, activeItem) {
      if (!this.hoverTitle || !this.hoverText) return;
      
      this.isTransitioning = true;
      
      // Find button if it exists
      const button = this.hoverTitle.parentElement?.querySelector('.hover-group-button');
      
      // Add transition class for smooth fade out
      this.hoverTitle.classList.add('content-changing');
      this.hoverText.classList.add('content-changing');
      if (button) {
        button.classList.add('content-changing');
      }
      
      // Wait for fade out, then update content and fade in
      setTimeout(() => {
        if (this.hoverTitle && this.hoverText) {
          this.hoverTitle.innerText = title;
          this.hoverText.innerHTML = text;
          
          // Remove transition class for fade in
          this.hoverTitle.classList.remove('content-changing');
          this.hoverText.classList.remove('content-changing');
        }
        if (button) {
          button.classList.remove('content-changing');
        }
        
        // Update active states
        this.hoverItems.forEach(img => img.classList.remove('active'));
        if (activeItem) {
          activeItem.classList.add('active');
        }
        
        // Reset transition flag
        setTimeout(() => {
          this.isTransitioning = false;
        }, 50);
      }, 100); // Half of the transition duration (200ms / 2)
    }
  }
  
  customElements.define('hover-text-handler', HoverTextHandler);

  // Handle window resize to reinitialize on desktop
  let resizeTimeout;
  window.addEventListener('resize', () => {
    clearTimeout(resizeTimeout);
    resizeTimeout = setTimeout(() => {
      // Reinitialize all hover text handlers on resize
      const handlers = document.querySelectorAll('hover-text-handler');
      handlers.forEach(handler => {
        // Remove existing instance and create new one
        const newHandler = document.createElement('hover-text-handler');
        if (handler.parentNode) {
          handler.parentNode.replaceChild(newHandler, handler);
        }
      });
    }, 250);
  });